import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminInternationalCountries from "@/pages/admin/AdminInternationalCountries";

export const Route = createFileRoute("/admin/internacional/paises")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminInternationalCountries />
    </AdminRoute>
  ),
});
